import * as React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Grid, List, ListItemButton, ListItemText, ListItemAvatar, Avatar, Paper, IconButton, ListItem, ListSubheader, Typography, Divider } from "@mui/material";
import { Close } from "@mui/icons-material";
import { modalConfirm } from "../../features/modal/modalSlice";
import moment from "moment";

const Records = ({ changeConfirm }) => {
    const { isAuth } = useSelector(state => state.auth)
    const { community, guests } = useSelector(state => state.records)
    const types = ['','👨🏻‍💻','👨🏻‍🎓','','👨🏻‍🏫','👨🏻‍💼']
    const dispatch = useDispatch();
    const modalUser = (id, item) => {
        changeConfirm(true);
        dispatch(modalConfirm({ id, item }))
    }
    const modalGuest = (id, item) => {
        changeConfirm(false);
        dispatch(modalConfirm({ id, item }))
    }
    return(
        <Grid container spacing={2}>
            { community.length ? (
                <Grid item xs={12} sm={12} md={6}>
                    <List 
                        component={Paper}
                        subheader={<ListSubheader>Comunidad Universitaria</ListSubheader>}
                    >
                        {community.map(({ id, nombre, codigo, tipo, createdAt }) => (
                            <React.Fragment key={id}>
                                <ListItem
                                    secondaryAction={ isAuth 
                                        ? <IconButton onClick={() => modalUser( id, `${codigo} - ${nombre}`)} color="secondary">
                                            <Close />
                                        </IconButton>
                                        : null
                                    }
                                >
                                    <ListItemButton>
                                        <ListItemAvatar><Avatar sx={{ bgcolor: 'white' }} >{types[tipo]}</Avatar></ListItemAvatar>
                                        <ListItemText
                                            primary={<Typography variant='body1' color={'primary'}><b>{codigo}</b></Typography>}
                                            secondary={<>
                                                <Typography sx={{ display: 'inline' }} component="span" variant="body1" color="text.primary">{nombre}</Typography>
                                                <br />
                                                {`${moment(createdAt).from()}`}
                                            </>}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Divider variant="inset" component={'li'} />
                            </React.Fragment>
                        ))}
                    </List>
                </Grid>
            ) : null }
            { guests.length ? (
                <Grid item xs={12} sm={12} md={6}>
                    <List 
                        component={Paper}
                        subheader={<ListSubheader>Externos</ListSubheader>}
                    >
                        {guests.map(({ id, nombre, dependencia, genero, createdAt }) => (
                            <React.Fragment key={id}>
                                <ListItem
                                    secondaryAction={ isAuth
                                        ? <IconButton onClick={() => modalGuest(id, `${nombre} - ${dependencia}`)} color="secondary">
                                            <Close />
                                        </IconButton>
                                        : null
                                    }
                                >
                                    <ListItemButton>
                                        <ListItemAvatar><Avatar sx={{ bgcolor: 'white' }}> { genero === 'H' ? '🙋🏻‍♂️' : '🙋🏻' }</Avatar></ListItemAvatar>
                                        <ListItemText
                                            primary={nombre}
                                            secondary={<>
                                                <Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">{dependencia}</Typography>
                                                {` - ${moment(createdAt).from()}`}
                                            </>}
                                        />
                                    </ListItemButton>
                                </ListItem>
                                <Divider variant="inset" component={'li'} />
                            </React.Fragment>
                        ))}
                    </List>
                </Grid>
            ) : null }
        </Grid>
    )
}

export default Records;